import React from 'react';
import { DocumentTypeQuery } from '../../../generated/graphql';
import {} from 'react-bootstrap';

interface DocumentTypeViewerProps {
    documentType: DocumentTypeQuery['documentType'];
}

export const DocumentTypeViewer: React.FC<DocumentTypeViewerProps> = ({ documentType }) => {
    const { name, values } = documentType;
    return (
        <div>
            <h1>{name}</h1>
            <p>{values}</p>
        </div>
    );
};
